import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[debounceClick]',
  standalone: true,
})
export class DebounceClickDirective {
  @Input() delay = 700;
  @Output() debounceClick = new EventEmitter<Event>();

  private isClicked = false;

  @HostListener('click', ['$event'])
  clickEvent(event: Event) {
    if (this.isClicked) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return;
    }

    this.isClicked = true;
    this.debounceClick.emit(event); // Solo emite si no estaba bloqueado

    setTimeout(() => (this.isClicked = false), this.delay);
  }
}